module.exports = __webpack_public_path__ + "media/images/top/recommend_t-d52ce4cae6710d9096b0872a86f778fa.gif";